"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../../utils");

var _sagas = _interopRequireDefault(require("./sagas"));

var actions = _interopRequireWildcard(require("./actions"));

var selectors = _interopRequireWildcard(require("./selectors"));

var _reducer = _interopRequireDefault(require("./reducer"));

var _default = function _default(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$storeName = _ref.storeName,
      storeName = _ref$storeName === void 0 ? 'resource' : _ref$storeName,
      camelCaseKeyPred = _ref.camelCaseKeyPred,
      snakeCaseKeyPred = _ref.snakeCaseKeyPred;

  var _createSagas = (0, _sagas.default)({
    camelCaseKeyPred,
    snakeCaseKeyPred
  }),
      rootSaga = _createSagas.rootSaga;

  return {
    actions,
    reducer: _reducer.default,
    sagas: rootSaga,
    selectors: (0, _utils.isolateSelectorsState)(storeName, selectors)
  };
};

exports.default = _default;